<template>
  <div
    id="dropdown"
    ref="dropdown"
    class="ui dropdown"
    :class="{ disabled: disabled, active: active }"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    @click.stop.prevent="click"
    v-on-clickaway="hide"
  >
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
.dropdown {
  positon: absolute;
  z-index: 100 !important;
}
</style>

<script>
// @flow
/**
 * Dropdown component.
 *
 */

import _ from 'lodash'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'dropdown',

  mixins: [clickaway],

  props: {
    active: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },

  computed: {},

  data() {
    return {}
  },

  methods: {
    show() {
      let menuEl = this.getMenuElement()
      if (menuEl) {
        menuEl.classList.add('visible')
        menuEl.classList.add('active')
        this.$emit('shown')
      } else {
        console.error('Dropdown menu element not found')
      }
    },
    hide() {
      let menuEl = this.getMenuElement()
      if (menuEl) {
        menuEl.classList.remove('visible')
        menuEl.classList.remove('active')
        this.$emit('hidden')
      } else {
        console.error('Dropdown menu element not found')
      }
    },
    getMenuElement() {
      let child = _.find(this.$children, c => _.includes(c.$el.classList, 'menu'))
      return child ? child.$el : this.$el.querySelector('.menu')
    },
    mouseenter() {
      this.$emit('mouseenter')
    },
    mouseleave() {
      this.$emit('mouseleave')
    },
    click() {
      this.$emit('click')
    }
  },
  watch: {
    active: {
      handler(active) {
        active ? this.show() : this.hide()
      },
      deep: true
    }
  }
}
</script>
